import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'
import LowerNavbar from '../../learning/california/california_classes';
import Uganda from './uganda';
import Uganda_s2_subjects from './uganda_s2_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_s2 = ( ) => {
 
  return (
    <>
    <TopNavbar />
   <Uganda />
   <International_countries />
  <Uganda_s2_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_s2;
